import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Marker from './Marker.jsx';
import { getProductMarkerNormalAsync, getProductMarkerHoverAsync } from '../../utils/StaticAssetManager';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import {getSceneInfoAsync, getSceneRoomObjectsAsync} from "../../utils/StoreConfigManager";
import {constructUrl} from "../../utils/UrlConstructor";
import { ZoomIconClicked } from '../../utils/Analytics.js';

const cdnUrl = 'https://cdn.obsess-vr.com/vacheron/'

export const ZoomMarkerTypes = Object.freeze({
    Zoom: "zoom",
});

export const ZoomImageAssets = Object.freeze({
    MagnifyingGlassIcon: cdnUrl + "Magnifying_glass_icon_hotspot.png"
});

class ZoomMarker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            normalSpriteUrl: '',
            hoverSpriteUrl: '',
        };
        this.mounted = false;
        this.productTitle = null;
        this.pendingProductHotspotClicked = null;
    }

    componentDidMount() {
        if(!this.props?.modal?.zoomModal){
            this.props.dispatch({type:'AP_MODAL_ADD_COMPONENT', payload:{
                    name:'ZoomModal',
                    status: false,
                    params:{}
                }});
        }
        
        switch (this.props.type) {
            case ZoomMarkerTypes.Zoom:
                this.setState({ normalSpriteUrl: ZoomImageAssets.MagnifyingGlassIcon});
                break;
           
            default:
                getProductMarkerNormalAsync()
                    .then(url => this.setState({ normalSpriteUrl: url }))
                    .catch(error => console.error(error));
                getProductMarkerHoverAsync()
                    .then(url => this.setState({ hoverSpriteUrl: url }))
                    .catch(error => console.error(error));
                break;
        }
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    onClick= async() =>{
        if (!this.mounted) return;
        const isMobile = isMobileDevice();
        const sceneID = this.props.scene['$oid'];
        const sceneHotspots = await getSceneRoomObjectsAsync(sceneID, {getProductRecordStatus:true});
        const sceneInfo = await getSceneInfoAsync(sceneID);
        if(isMobile){
            const fileName = sceneInfo['mobile_flat_scene_url']?.path.split('/').pop();
            ZoomIconClicked(fileName);
        }else{
            const fileName = sceneInfo['flat_scene_url']?.path.split('/').pop();
            ZoomIconClicked(fileName);
        }
        //Display only hotspots that having associated product record
        const hotspotsWithProductData= sceneHotspots.filter(item=>item?.props.published === true)
        this.props.dispatch({type:'AP_MODAL_SET_STATUS', payload:{
                name:'ZoomModal',
                status:true,
                params:{
                    scene:sceneID,
                    hotspots:hotspotsWithProductData,
                    bgUrl: isMobile ? constructUrl(sceneInfo['mobile_flat_scene_url']) : constructUrl(sceneInfo['flat_scene_url']) ,
                }
            }});
    }




    render() {
        const { normalSpriteUrl } = this.state;

        return (
            <div>
                <Marker
                    transform={this.props.transform}
                    colliderTransform={this.props.colliderTransform}
                    normalSpriteUrl={normalSpriteUrl}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                    showVisual={this.props.showVisual}
                    onClick={this.onClick}
                />
            </div>
        );
    }
}





ZoomMarker.propTypes = {
    color: PropTypes.string,
    productSKU: PropTypes.string.isRequired,
    transform: PropTypes.array.isRequired,
    colliderTransform: PropTypes.array.isRequired,
    specialUrl: PropTypes.string,
    primaryColor: PropTypes.string.isRequired,
    secondaryColor: PropTypes.string.isRequired
};

const mapStateToProps=({modal})=> ({modal});

export default connect(mapStateToProps)(ZoomMarker);
